import { shouldPublish } from "src/utils/publishUtils";
import { promotionCategoryMatchesRoute } from "src/utils/promotionCategory";

/**
 * Filters promotion hub cards by publish window and optional category route slug.
 *
 * @param {import('src/utils/mapPromotion').PromotionCard[]} cards
 * @param {string} [routeCategory] - `params.category` from react-router (EN or FR URL segment)
 * @param {{ livePreviewKey?: string }} [options]
 * @returns {import('src/utils/mapPromotion').PromotionCard[]}
 */
export function filterPromotionCards(cards, routeCategory, options = {}) {
  const { livePreviewKey } = options;
  if (!Array.isArray(cards)) return [];

  return cards.filter((card) => {
    const isLiveCard = livePreviewKey && card.key === livePreviewKey;
    if (!isLiveCard && !shouldPublish(card)) return false;

    if (routeCategory) {
      return promotionCategoryMatchesRoute(routeCategory, card.category);
    }

    return true;
  });
}
